import {
  SET_WEBSITE_MODE,
  SET_CURRENT_FILE_KEY,
  SET_DATA_STATUS,
  SET_CURRENT_TAB_INDEX,
  SET_CURRENT_TAB_DATA,
  ADD_NEW_TAB_DATA,
  DELETE_TAB_DATA,
  SET_TOOL_SETTINGS_ACTIVE_INDEX,
  SET_IS_TOOL_SPINNING,
  SET_FULLSCREEN_ACTIVE,
  SET_ALL_RESULTS_HAS_UPDATE,
  SET_TITLE_POPUP_INDEX,
  SET_FREEZE_EDITING,
  SET_IS_READING_FILE,
  SET_TOOL_SETTINGS_MORPHING,
  SET_TOOL_SETTINGS_ORIGIN,
} from './constants'
// import { setLoadSaveDataRIG } from '../rig/actions'
// import { setLoadSaveDataRTG } from '../rtg/actions'
import {
  updateAllSettings,
  resetInitialSettings,
} from '../toolSettings/actions'
import { updateCurrentConfig } from '../shareWheel/actions'
// import { entries, clear, setMany } from 'idb-keyval'

export const setWebsiteMode = mode => ({
  type: SET_WEBSITE_MODE,
  payload: {
    mode,
  },
})

export const setCurrentFileKey = key => {
  return {
    type: SET_CURRENT_FILE_KEY,
    payload: {
      key,
    },
  }
}

export const setDataStatus = (status, modifiedField = '') => ({
  type: SET_DATA_STATUS,
  payload: {
    status,
    modifiedField,
  },
})

export const setCurrentTabData = data => ({
  type: SET_CURRENT_TAB_DATA,
  payload: {
    data,
  },
})

export const deleteTabData = (page, index) => async (dispatch, getState) => {
  const state = getState()
  let newCurrentIndex = state.common.currentTabIndex
  // debugger
  if (newCurrentIndex === index) {
    if (newCurrentIndex === state.common.tabsData.length - 1) {
      await dispatch(setCurrentTabIndex(page, newCurrentIndex - 1, true))
      newCurrentIndex = newCurrentIndex - 1
    } else {
      await dispatch(setCurrentTabIndex(page, newCurrentIndex + 1, true))
      newCurrentIndex = newCurrentIndex
    }
  } else if (index < newCurrentIndex) {
    newCurrentIndex = newCurrentIndex - 1
  }
  dispatch({
    type: DELETE_TAB_DATA,
    payload: {
      index,
      newCurrentIndex,
    },
  })
}

export const storeTabData = page => async (dispatch, getState) => {
  const state = getState()
  let data = {
    name: '',
    ...state.common.tabsData[state.common.currentTabIndex],
    id: state.common.currentFileKey,
    dataStatus: state.common.dataStatus,
    freezeEditing: state.common.freezeEditing,
    currentConfigShare: state.share.currentConfig,
  }
  const toolTitle = state[page].title
  if (toolTitle.active) {
    data['title'] = toolTitle
  } else {
    data['title'] = { active: false, text: '', description: '', popup: '' }
  }

  // if (page !== 'rtg') {
  const {
    resultSelected,
    title,
    turnTable,
    turnTableSize,
    savedChoicesList,
    inputKeyText,
    keyTextRTG,
    savedPeopleList,
    ...rest
  } = state[page]
  data = {
    ...data,
    ...rest,
  }

  // if (data['settings']) {
  const fSettings = state.settings
  const settingsData = { ...fSettings }
  if (settingsData.hasOwnProperty('_persist')) {
    delete settingsData._persist
  }

  data['settings'] = settingsData
  // const storedCustomizations = await entries()
  // if (storedCustomizations.length > 0) {
  //   data['customizations'] = storedCustomizations
  // } else {
  //   data['customizations'] = []
  // }

  // }

  dispatch(setCurrentTabData(data))
}

export const setCurrentTabIndex =
  (page, index, skipStoreData = false) =>
  async (dispatch, getState) => {
    if (!skipStoreData) await dispatch(storeTabData(page))
    const state = getState()

    const listData = state.common.tabsData[index]

    if (Object.keys(listData).length === 1 && listData.tabNumber) {
      //newtab
      await dispatch(resetInitialSettings())
      dispatch({
        type: `RESET_INITIAL_STATE_${page.toUpperCase()}`,
      })
      dispatch(setFreezeEditing(false))
      dispatch(setCurrentFileKey(''))
      dispatch(updateCurrentConfig(null))
    } else {
      await dispatch(updateAllSettings(listData['settings'], page))
      const {
        dataStatus,
        id = '',
        label,
        name,
        settings,
        tabNumber,
        uniqueId,
        currentConfigShare,
        freezeEditing,
        ...newStateData
      } = listData
      let newFileKey = id
      // let newCurrentConfig = null
      // switch (page) {
      //   case 'main':
      //   case 'rig':
      //   case 'rtg':
      //     newFileKey = id
      //     break
      // }
      // newCurrentConfig = currentConfigShare
      dispatch({
        type: `REPLACE_STATE_${page.toUpperCase()}`,
        payload: {
          data: { ...newStateData, turnTable: null },
        },
      })
      dispatch(setFreezeEditing(freezeEditing))
      dispatch(updateCurrentConfig(currentConfigShare))
      dispatch(setCurrentFileKey(newFileKey))
    }

    dispatch(setDataStatus(listData.dataStatus))
    dispatch(setToolSettingsActiveIndex(1))
    dispatch({
      type: SET_CURRENT_TAB_INDEX,
      payload: {
        index,
      },
    })
  }

export const addNewTabData = page => (dispatch, getState) => {
  const newIndex = getState().common.tabsData.length
  dispatch({
    type: ADD_NEW_TAB_DATA,
  })
  dispatch(setCurrentTabIndex(page, newIndex))
}

export const setToolSettingsActiveIndex = value => ({
  type: SET_TOOL_SETTINGS_ACTIVE_INDEX,
  payload: {
    value,
  },
})

export const setIsToolSpinning = status => ({
  type: SET_IS_TOOL_SPINNING,
  payload: {
    status,
  },
})

export const setFullScreenActive = status => ({
  type: SET_FULLSCREEN_ACTIVE,
  payload: {
    status,
  },
})

export const setAllResultsHasUpdate = status => ({
  type: SET_ALL_RESULTS_HAS_UPDATE,
  payload: {
    status,
  },
})

export const setTitlePopupIndex = index => ({
  type: SET_TITLE_POPUP_INDEX,
  payload: {
    index,
  },
})

export const updateTitlePopupIndex = page => (dispatch, getState) => {
  const titlePopupIndex = getState().common.titlePopupIndex
  const { popup } = getState()[page].title
  const popupArray = popup.split('\n')
  if (popupArray.length > 1) {
    const newIndex = titlePopupIndex + 1
    if (newIndex < popupArray.length) {
      dispatch(setTitlePopupIndex(titlePopupIndex + 1))
    } else {
      dispatch(setTitlePopupIndex(0))
    }
  }
}

export const setFreezeEditing = status => ({
  type: SET_FREEZE_EDITING,
  payload: {
    status,
  },
})

export const setIsReadingFile = status => ({
  type: SET_IS_READING_FILE,
  payload: {
    status,
  },
})

export const setToolSettingsMorphing = status => ({
  type: SET_TOOL_SETTINGS_MORPHING,
  payload: {
    status,
  },
})

export const setToolSettingsOrigin = value => ({
  type: SET_TOOL_SETTINGS_ORIGIN,
  payload: {
    value,
  },
})
